import styled from "styled-components";

const FloatingRow = styled.div`
  position: fixed;
  width: 100%;
  left: 0px;
  bottom: 70px;

  display: flex;
  justify-content: center;
  gap: 15px;

  @media( min-width: 768px ){
    width: calc(calc(calc(100%/6) * 5) - 30px);
    left: calc(calc(100%/6) + 30px);
    bottom: 25px;
  }
`;

export default FloatingRow;